import { render } from "./Swiper.vue?vue&type=template&id=2949f6d4&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=2949f6d4&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-2949f6d4"

export default script